/**
 * Beta access control for features not yet available to all users.
 * Add / remove email addresses here to manage beta access.
 */
const BETA_EMAILS = new Set([
  "malikmzl123@gmail.com",
  "aixonaholding@gmail.com",
]);

export function isBetaUser(email: string | null | undefined): boolean {
  if (!email) return false;
  return BETA_EMAILS.has(email.toLowerCase().trim());
}
